import { useQuery } from '@tanstack/react-query';
import {
  fetchReviewMonthlyTrend,
  fetchReviews,
  fetchReviewStats,
} from '../../services/accommodationService';

export function useReviews(
  propertyId: string | null | undefined,
  page = 1,
  pageSize = 20,
) {
  return useQuery({
    queryKey: ['accommodation-reviews', propertyId, page, pageSize],
    queryFn: () => fetchReviews(propertyId!, page, pageSize),
    enabled: !!propertyId,
    staleTime: 60_000,
  });
}

export function useReviewStats(
  propertyId: string | null | undefined,
  dateFrom?: string,
  dateTo?: string,
) {
  return useQuery({
    queryKey: ['accommodation-review-stats', propertyId, dateFrom, dateTo],
    queryFn: () => fetchReviewStats(propertyId!, dateFrom, dateTo),
    enabled: !!propertyId,
    staleTime: 60_000,
  });
}

export function useReviewMonthlyTrend(
  propertyId: string | null | undefined,
  months = 12,
) {
  return useQuery({
    queryKey: ['accommodation-review-trend', propertyId, months],
    queryFn: () => fetchReviewMonthlyTrend(propertyId!, months),
    enabled: !!propertyId,
    staleTime: 60_000,
  });
}
